import React from 'react';
import PropTypes from 'prop-types';

const LogoInvestingClub = ({ style }) => (
  <svg
    width="128"
    height="40"
    viewBox="0 0 128 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_903_765)">
      <rect width="127.5" height="40" fill="white" />
      <g clipPath="url(#clip1_903_765)">
        <path d="M39.9524 0H0V40H39.9524V0Z" fill="#0053CF" />
        <path
          d="M13.4802 24.1852H14.9673L18.0304 28.2889V24.1852H19.4213V30.5259H17.9342L14.8712 26.4148V30.5259H13.4802V24.1852Z"
          fill="white"
        />
        <mask
          id="mask0_903_765"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="128"
          height="40"
        >
          <path d="M127.5 0H0V40H127.5V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_903_765)">
          <path
            d="M26.5093 28.5333C26.5093 30.2593 25.1257 30.5333 24.2675 30.5333H20.583V24.1852H24.2675C25.3921 24.1852 26.2947 24.8296 26.2947 26.0296C26.2947 26.6222 25.873 26.9555 25.5549 27.1111C26.0802 27.3778 26.5093 27.763 26.5093 28.5333ZM21.9296 25.3778V26.5778H24.1047C24.4673 26.5778 24.8594 26.4296 24.8594 25.9852C24.8594 25.5407 24.5561 25.3778 24.0529 25.3778H21.9296ZM25.0814 28.5333C25.0814 27.9259 24.5782 27.763 24.0825 27.763H21.9296V29.2815H24.1343C24.5339 29.2815 25.0814 29.1407 25.0814 28.5333Z"
            fill="white"
          />
          <path
            d="M33.5379 29.4963C32.8424 30.0888 32.0951 30.6963 30.6154 30.6963C28.6474 30.6888 27.1233 29.1629 27.1233 27.3407C27.1307 25.4666 28.7214 24.0148 30.6376 24.0148C32.2949 24.0148 33.1901 25.0814 33.3085 25.2L32.2579 26.2444C32.0286 26.0148 31.5403 25.4888 30.6228 25.4888C29.5056 25.4888 28.603 26.3259 28.603 27.3481C28.603 28.2444 29.3725 29.2074 30.6154 29.2074C31.6068 29.2074 31.9694 28.8814 32.5835 28.3703L33.5379 29.4888V29.4963Z"
            fill="white"
          />
          <path
            d="M12.844 29.4963C12.1486 30.0888 11.4013 30.6963 9.92158 30.6963C7.95355 30.6888 6.42944 29.1629 6.42944 27.3407C6.43684 25.4666 8.02754 24.0148 9.94378 24.0148C11.6011 24.0148 12.4963 25.0814 12.6147 25.2L11.5641 26.2444C11.3347 26.0148 10.8464 25.4888 9.92898 25.4888C8.81179 25.4888 7.90916 26.3259 7.90916 27.3481C7.90916 28.2444 8.67862 29.2074 9.92158 29.2074C10.913 29.2074 11.2755 28.8814 11.8896 28.3703L12.844 29.4888V29.4963Z"
            fill="white"
          />
          <path
            d="M24.8815 12.563L21.5669 20.1407L20.6199 13.5556C20.5015 12.6593 22.0182 12.1111 22.0182 12.1111C21.8777 11.8 21.3968 11.8074 21.3968 11.8074H20.3684C20.2056 10.1852 21.6705 9.0074 23.2612 9.37037C24.8223 9.71851 25.3846 11.4148 24.8815 12.563Z"
            fill="white"
          />
          <path
            d="M18.726 22.5926L12.267 18.2815C10.6245 17.1852 8.9968 18.3037 8.64907 19.4593C8.13856 21.1704 9.27795 22.5926 11.0684 22.5926H18.726Z"
            fill="white"
          />
          <path
            d="M19.5768 11.9111C19.8136 10.237 18.3191 8.99999 16.6988 9.37036C15.1377 9.71851 14.5754 11.4148 15.0785 12.563L18.3931 20.1407L19.5768 11.9111Z"
            fill="white"
          />
          <path
            d="M18.1265 21.3852L14.9451 14.1259C14.1979 12.4445 12.2298 12.2371 11.1422 13.2222C10.3728 13.9185 9.7809 15.8148 11.4974 16.9556L18.1339 21.3852H18.1265Z"
            fill="white"
          />
          <path
            d="M28.8917 22.5925C30.6821 22.5925 31.8141 21.1703 31.311 19.4592C30.9633 18.3037 29.343 17.1777 27.6931 18.2814L21.2341 22.5925H28.8917Z"
            fill="white"
          />
          <path
            d="M28.47 16.9629C30.1864 15.8148 29.5871 13.9259 28.8251 13.2296C27.7375 12.2444 25.7621 12.4518 25.0222 14.1333L21.8408 21.3925L28.4774 16.9629H28.47Z"
            fill="white"
          />
          <path d="M127.508 0H42.0464V40H127.508V0Z" fill="#0053CF" />
          <path
            d="M54.8828 20.0444V20C54.8828 15.5926 58.1826 11.9778 62.8733 11.9778C65.7292 11.9778 67.4604 12.9778 68.9401 14.3926L67.1941 16.4074C65.9511 15.2519 64.6268 14.4815 62.8585 14.4815C59.9139 14.4815 57.7461 16.9185 57.7461 19.9556V20C57.7461 23.037 59.8917 25.4963 62.8585 25.4963C64.7599 25.4963 65.9807 24.7407 67.3051 23.5037L69.0511 25.2741C67.4382 26.9556 65.6626 28.0222 62.7623 28.0222C58.2492 28.0222 54.8828 24.4963 54.8828 20.0444Z"
            fill="white"
          />
          <path
            d="M72.2029 12.2444H74.9256V25.274H83.0714V27.7555H72.2029V12.2444Z"
            fill="white"
          />
          <path
            d="M84.8916 21.1777V12.2444H87.6143V21.0666C87.6143 23.9481 89.094 25.474 91.5355 25.474C93.9771 25.474 95.4346 24.0296 95.4346 21.1777V12.2444H98.1573V21.0444C98.1573 25.674 95.5456 27.9999 91.4912 27.9999C87.4367 27.9999 84.8916 25.674 84.8916 21.1703"
            fill="white"
          />
          <path
            d="M101.76 12.2444H108.715C110.483 12.2444 111.882 12.7333 112.769 13.6222C113.457 14.3111 113.813 15.1481 113.813 16.1925V16.237C113.813 18.0962 112.747 19.0962 111.6 19.6962C113.413 20.3185 114.678 21.3555 114.678 23.4666V23.5111C114.678 26.2814 112.399 27.7703 108.944 27.7703H101.768V12.2518L101.76 12.2444ZM111.082 16.637C111.082 15.4148 110.106 14.6666 108.36 14.6666H104.439V18.7851H108.16C109.906 18.7851 111.082 18.0962 111.082 16.6814V16.637ZM108.759 21.0888H104.446V25.3407H108.959C110.824 25.3407 111.948 24.6073 111.948 23.2148V23.1703C111.948 21.8592 110.905 21.0888 108.759 21.0888Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_903_765">
        <rect width="127.5" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_903_765">
        <rect width="127.5" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LogoInvestingClub;

LogoInvestingClub.propTypes = {
  style: PropTypes.shape(PropTypes.CSSProperties),
};

LogoInvestingClub.defaultProps = {
  style: {},
};
